import appBuilder from './AppBuilder'

appBuilder.build()
